import React from "react";
import { motion } from "framer-motion";

import LandingNav from "./components/LandingNav";
import HeroSection from "./components/HeroSection";
import ProductOverview from "./components/ProductOverview";
import HowItWorks from "./components/HowItWorks";
import WhyItMatters from "./components/WhyItMatters";
import ForWhom from "./components/ForWhom";
import AdvancedPDFReportSection from "./components/AdvancedPDFReportSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const LandingPage = () => {
  return (
    <div className="w-full min-h-screen overflow-x-hidden">
      <LandingNav />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="w-full"
      >
        <HeroSection />
        <ProductOverview />
        <HowItWorks />
        <WhyItMatters />
        <ForWhom />
        <AdvancedPDFReportSection />
        <CTASection />
        <Footer />
      </motion.main>
    </div>
  );
};

export default LandingPage;
